export default "__VITE_ASSET__kAlVLo5$__"